import React from 'react';
import {Row, Col, Button} from "react-bootstrap";
import Card from "../../Card";
import cookie from "react-cookies";
import {faCheck, faInfoCircle, faTimes} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {connect} from "react-redux";
import {withRouter} from "react-router"
import {bindActionCreators} from "redux";
import {launchProjector} from "../../../app/slices/projectorSlice";
import GoogleAnalyticsUtils from "../../../util/GoogleAnalyticsUtils";

class Launch extends React.Component {
    constructor(props) {
        super(props);
        const webcamConfig = cookie.load("webcamConfig")
        const laserConfig = cookie.load("laserConfig")
        this.state = {
            status: "welcome",
            projectorStatus: "none",
            laserStatus: !!laserConfig ? "ready" : "none",
            webcamStatus: !!webcamConfig ? "ready" : "none",
            videoReady: false
        }

        if (!!props.resized) {
            this.state.status = "resized"
        }
    }

    componentDidMount() {
        GoogleAnalyticsUtils.pageview(window.location.pathname + window.location.search);
    }

    static getDerivedStateFromProps(props, state) {
        if (!!props.projectorReady) {
            state["projectorStatus"] = "ready"
            return state
        }
        return null;
    }

    render() {
        const ready = this.state.projectorStatus === "ready" && this.state.laserStatus === "ready" && this.state.webcamStatus === "ready";
        return (
            <>
                <Row>
                    <Col sm={12} className={"text-center"}>
                        <p>사격을 시작하기 전에 프로젝터 화면을 실행하고, 웹캠과 레이저를 보정해야 합니다.
                        </p>
                        <p>모든 항목이 준비되면 "사격 시작"를 클릭하세요.</p>
                    </Col>
                </Row>
                <Row style={{marginTop: "10px"}}>
                    <Col sm={4}>
                        <Card >
                            <div className={"text-center"}>
                                <h5 style={{textDecoration: "underline"}}>프로젝터 상태</h5>
                                {this.state.projectorStatus === "none" ?
                                    <>
                                        <p>실행 대기중</p>
                                        <p><FontAwesomeIcon icon={faTimes} style={{color: "red"}}/></p>
                                    </>
                                    : this.state.projectorStatus === "resizing" ?
                                        <>
                                            <p>화면 조정 대기중</p>
                                            <p><FontAwesomeIcon icon={faTimes} style={{color: "red"}}/></p>
                                        </>
                                        :
                                        <>
                                            <p>준비됨</p>
                                            <p><FontAwesomeIcon icon={faCheck} style={{color: "green"}}/></p>
                                        </>}
                                <Button variant="customPrimary" onClick={() => {this.props.launchProjector()}} disabled={this.state.projectorStatus !== "none"}>프로젝터 화면 실행</Button>
                            </div>
                        </Card>
                    </Col>
                    <Col sm={4}>
                        <Card >
                            <div className={"text-center"}>
                                <h5 style={{textDecoration: "underline"}}>웹캠 보정 상태</h5>
                                {this.state.webcamStatus === "none" ?
                                    <>
                                        <p>보정 대기중</p>
                                        <p><FontAwesomeIcon icon={faTimes} style={{color: "red"}}/></p>
                                    </>
                                    :
                                    <>
                                        <p>준비됨</p>
                                        <p><FontAwesomeIcon icon={faCheck} style={{color: "green"}}/></p>
                                    </>
                                }
                                <Button variant="customPrimary" onClick={() => {this.props.history.push('/calibrateWebcam')}} disabled={this.state.projectorStatus !== "ready"}>웹캠 보정</Button>
                                {this.state.projectorStatus !== "ready" && <><br /><span style={{fontSize: "80%"}}>보정 전에 프로젝터 화면을 실행하세요</span></>}
                            </div>
                        </Card>
                    </Col>
                    <Col sm={4}>
                        <Card >
                            <div className={"text-center"}>
                                <h5 style={{textDecoration: "underline"}}>레이저 보정 상태</h5>
                                {this.state.laserStatus === "none" ?
                                    <>
                                        <p>보정 대기중</p>
                                        <p><FontAwesomeIcon icon={faTimes} style={{color: "red"}}/></p>
                                    </>
                                :
                                    <>
                                        <p>준비됨</p>
                                        <p><FontAwesomeIcon icon={faCheck} style={{color: "green"}}/></p>
                                    </>
                                }
                                <Button variant="customPrimary" onClick={() => {this.props.history.push('/calibrateLaser')}} disabled={this.state.projectorStatus !== "ready"}>레이저 보정</Button>
                                {this.state.projectorStatus !== "ready" && <><br /><span style={{fontSize: "80%"}}>보정 전에 프로젝터 화면을 실행하세요</span></>}
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row style={{marginTop: "20px"}}>
                    <Col sm={12} className={"text-center"}>
                        <Button variant="customPrimary" onClick={() => {this.props.history.push('/selectMode')}} disabled={!ready} size="lg">사격 시작</Button>
                    </Col>
                </Row>
            </>
        );
    }

}

const mapStateToProps = state => ({
    projectorReady: state.projector.resized
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators({launchProjector}, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Launch));